import { gql } from '@apollo/client';

export default gql`
  mutation RedeemVoucher(
    $reference: String!
    $market: String
    $channel: Channel
    $operation: String
    $amount: Float
    $cid: String
    $bookingReference: String!
    $sendRedeemEmail: Boolean
    $isDeposit: Boolean = false
  ) {
    redeemVoucher(
      reference: $reference
      market: $market
      channel: $channel
      operation: $operation
      amount: $amount
      cid: $cid
      bookingReference: $bookingReference
      sendRedeemEmail: $sendRedeemEmail
      isDeposit: $isDeposit
    ) {
      datacashReference
      amountRedeemed
      currencyRedeemed
      voucher {
        reference
        alias
        type
        amount
        currency
        validUntil
      }
    }
  }
`;
